const basico5 = {
  titulo: `JavaScript: API fetch`,
  problemas: [
    {
      codigo: 1,
      descripcion: `API fetch es una API que permite hacer peticiones HTTP a un servidor y esta implementado con promesas. Este API remplaza las peticiones asíncronas que se han hecho por muchos años utilizando el objeto XMLHttpRequest.
Todos los navegadores han implementado esta API y podemos consultar el estandar de la API <a href="https://fetch.spec.whatwg.org/" target="_blank">aquí</a>            
El API fetch se base en un método llamado 'fetch' que depende del objeto 'window' como sucede con otros métodos como 'alert', 'prompt' etc.<br>
La sintaxis es muy sencilla, si tenemos que solicitar un archivo con formato JSON:
<code>
[{
  "codigo": 1,
  "nombre": "carnes"
},
{
  "codigo": 2,
  "nombre": "frutas"
},
{
  "codigo": 3,
  "nombre": "verduras"
}]
</code>
a un servidor web tenemos que implementar la siguiente sintaxis:
<code>
fetch('https://www.scratchya.com.ar/apifetch/recuperarrubros.php')
     .then(respuesta => respuesta.json())
     .then(rubros => console.log(rubros))
</code>      
La función fetch() devuelve una promesa que se resuelve con el objeto 'respuesta' que contiene la respuesta del servidor. Luego podemos usar el método 'json()' para convertir el objeto 'respuesta' en un objeto JSON, con estas simples líneas ya tenemos en el parámetro rubros los datos del servidor.
`,
      programa: `fetch('https://www.scratchya.com.ar/apifetch/recuperarrubros.php')
  .then(respuesta => respuesta.json())
  .then(rubros => {
    const rubro1 = [rubros[0].codigo, rubros[0].nombre]
    console.log(rubro1)
  })`,
      solucion: "[1, 'carnes']"
    }, {
      codigo: 2,
      descripcion: `
`,
      programa: `fetch('https://www.scratchya.com.ar/apifetch/recuperarrubros.php')
  .then(respuesta => respuesta.json())
  .then(rubros => {
      const descripciones = []
      for(let rubro of rubros) {
        descripciones.push(rubro.nombre)
      }
      console.log(descripciones)
})`,
      solucion: "['carnes', 'frutas', 'verduras']"
    }, {
      codigo: 3,
      descripcion: `Veamos otro ejemplo, supongamos que tenemos una base de datos de artículos en nuestro servidor que se encuentra relacionado con los datos de rubros del problema anterior.
Si recuperaramos todos los datos tenemos el siguiente resultado:
<code>
[{
  "codigo": 1,
  "codigorubro": 1,
  "nombre": "asado",
  "precio": 1200
},
{
  "codigo": 2,
  "codigorubro": 1,
  "nombre": "milanesa",
  "precio": 900
},
{
  "codigo": 3,
  "codigorubro": 1,
  "nombre": "churrasco",
  "precio": 1000
},
{
  "codigo": 4,
  "codigorubro": 2,
  "nombre": "naranjas",
  "precio": 120
},
{
  "codigo": 5,
  "codigorubro": 2,
  "nombre": "peras",
  "precio": 318
},
{
  "codigo": 6,
  "codigorubro": 2,
  "nombre": "manzanas",
  "precio": 250
},{
  "codigo": 7,
  "codigorubro": 3,
  "nombre": "tomate",
  "precio": 180
},
{
  "codigo": 8,
  "codigorubro": 3,
  "nombre": "lechuga",
  "precio": 90
}]
</code>
Luego disponemos en nuestro servidor de un api que retorna todos los productos de un rubro en particular que le pasamos como parámetro:
<code>
https://www.scratchya.com.ar/apifetch/recuperararticulos.php?rubro=1
</code>
Nos debería retornar los siguientes datos:
<code>
[{
  "codigo": 1,
  "codigorubro": 1,
  "nombre": "asado",
  "precio": 1200
},
{
  "codigo": 2,
  "codigorubro": 1,
  "nombre": "milanesa",
  "precio": 900
},
{
  "codigo": 3,
  "codigorubro": 1,
  "nombre": "churrasco",
  "precio": 1000
}]
</code>
`,
      programa: `fetch('https://www.scratchya.com.ar/apifetch/recuperararticulos.php?rubro=2')
    .then(respuesta => respuesta.json())
    .then(articulos => {				
        console.log(articulos)
    })`,
      solucion: "[{codigo: 4, codigorubro: 2, nombre: 'naranjas', precio: 120}, {codigo: 5, codigorubro: 2, nombre: 'peras', precio: 318}, {codigo: 6, codigorubro: 2, nombre: 'manzanas', precio: 250}]"
    }, {
      codigo: 4,
      descripcion: `
`,
      programa: `fetch('https://www.scratchya.com.ar/apifetch/recuperararticulos.php?rubro=2')
.then(respuesta => respuesta.json())
.then(articulos => {
  console.log(Math.max(...articulos.map(articulo => articulo.precio)))
})`,
      solucion: "318"
    }, {
      codigo: 5,
      descripcion: `
`,
      programa: `fetch('https://www.scratchya.com.ar/apifetch/recuperararticulos.php?rubro=1')
    .then(respuesta => respuesta.json())
    .then(articulos => {
      console.log(articulos.map(articulo => articulo.nombre))
    })`,
      solucion: "['asado', 'milanesa', 'churrasco']"
    }, {
      codigo: 6,
      descripcion: `Podemos recuperar archivos de un servidor con formato de texto. Supongamos que en nuestro servidor tenemos un archivo de texto por cada signo del zodiaco. Por ejemplo:
virgo.txt
<code>
contenido: aventurero, inteligente, tenaz y persistente      
</code>
<p>Luego podemos recuperar el contenido y transformarlo a modo texto con la siguiente sintaxis: 
<code>
fetch('https://www.tutorialesprogramacionya.com/herramientas/aries.txt')
    .then(respuesta => respuesta.text())
    .then(contenido => {
        console.log(contenido)
    })
</code>
Y también podemos recuperar el contenido de archivos con formato binario como imágenes, archivos de audio o video:
<code>
fetch('https://www.tutorialesprogramacionya.com/herramientas/aries.png')
    .then(response => response.blob())
    .then(datos => console.log(datos))      
</code>
Algo muy importante es que nuestro servidor este configurado para que los archivos sean accesibles desde sitio web que los solicite mediante la API fetch.
`,
      programa: `fetch('https://www.tutorialesprogramacionya.com/herramientas/aries.txt')
    .then(response => response.text())
    .then(datos => console.log(datos))`,
      solucion: "'aventurero, inteligente, tenaz y persistente'"
    }, {
      codigo: 7,
      descripcion: `Para procesar errores podemos usar la función catch() de la promesa.
<code>
fetch('https://www.scratchya.com.ar/apifetch/recuperarrubrosxxx.php')
    .then(respuesta => respuesta.json())
    .then(rubros => console.log(rubros))
    .catch(error => console.log('problema :'+error))      
</code>
Si hacemos una petición a una url inexistente: https://www.scratchya.com.ar/apifetch/recuperarrubrosxxx.php
Se ejecutará el catch() y mostrará el error respectivo: problema :TypeError: Failed to fetch   
`,
      programa: `fetch('https://www.scratchya.com.ar/apifetch/recuperarrubrosxxx.php')
    .then(respuesta => respuesta.json())
    .then(rubros => console.log(rubros))
    .catch(error => console.log('error de peticion'))`,
      solucion: "'error de peticion'"
    }, {
      codigo: 8,
      descripcion: `El primer método then recibe un objeto que tiene entre otras propiedades: 'ok', 'status', 'statusText', 'url', 'type', 'headers', 'redirected', 'body' etc.
Veamos un ejemplo:
<code>
fetch('https://www.scratchya.com.ar/apifetch/recuperarrubros.php')
    .then(respuesta =>{ 
      console.log(respuesta.status) // 200
      console.log(respuesta.statusText) // OK
      console.log(respuesta.ok) // true
      return respuesta.json()
})
.then(rubros => console.log(rubros))       
</code>
Estos datos nos pueden ser de utilidad para identificar errores por ejemplo.
`,
      programa: `fetch('https://www.scratchya.com.ar/apifetch/recuperarrubros.php')
    .then(respuesta =>{ 
        console.log(respuesta.status) 
    })`,
      solucion: "200"
    }
  ]
}

export default basico5;

